import React from 'react';

const SmallLockIcon = ({
  width = '20',
  height = '20',
  color = '#222222',
  className = '',
}) => {
  return (
    <svg
      data-testid="lock-icon"
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.895431 0 0 0.895431 0 2L0 18C0 19.1046 0.895431 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0L2 0ZM13 9H13.022C13.2814 9 13.5301 9.10304 13.7136 9.28645C13.897 9.46986 14 9.71862 14 9.978V15.022C14 15.1504 13.9747 15.2776 13.9256 15.3963C13.8764 15.5149 13.8044 15.6227 13.7136 15.7136C13.6227 15.8044 13.5149 15.8764 13.3963 15.9256C13.2776 15.9747 13.1504 16 13.022 16H6.978C6.71862 16 6.46986 15.897 6.28645 15.7136C6.10304 15.5301 6 15.2814 6 15.022V9.978C6 9.71862 6.10304 9.46986 6.28645 9.28645C6.46986 9.10304 6.71862 9 6.978 9H7V7C7 6.20435 7.31607 5.44129 7.87868 4.87868C8.44129 4.31607 9.20435 4 10 4C10.7956 4 11.5587 4.31607 12.1213 4.87868C12.6839 5.44129 13 6.20435 13 7V9ZM8.93934 5.93934C8.65804 6.22064 8.5 6.60218 8.5 7V9H11.5V7C11.5 6.60218 11.342 6.22064 11.0607 5.93934C10.7794 5.65804 10.3978 5.5 10 5.5C9.60218 5.5 9.22064 5.65804 8.93934 5.93934Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};

export default SmallLockIcon;
